module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "device-managment-pc"
  }, [_c('div', {
    staticClass: "management-title"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('span', [_vm._v(_vm._s(_vm.$tc('title', 0)) + " " + _vm._s(_vm.user.max_device_count) + " " + _vm._s(_vm.user.max_device_count > 1 ? _vm.$tc('title', 2) : _vm.$tc('title', 1)))]), _vm._v(" "), _c('div', {
    staticClass: "new-tips"
  }, [_vm._v("*" + _vm._s(_vm.$t('new_tips')))])]), _vm._v(" "), _c('router-link', {
    staticClass: "add-device-num",
    attrs: {
      "tag": "span",
      "to": "/dashboard"
    }
  }, [_vm._v(_vm._s(_vm.$t('add_device')))])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasFetch && _vm.records.length === 0),
      expression: "hasFetch && records.length === 0"
    }],
    staticClass: "no-record"
  }, [_vm._v(_vm._s(_vm.$t('no_data')))]), _vm._v(" "), (_vm.records.length > 0) ? _c('div', {
    attrs: {
      "id": "list-box"
    }
  }, _vm._l((_vm.records), function(item, index) {
    return _c('div', {
      key: item.id,
      staticClass: "records"
    }, [_c('div', {
      staticClass: "platform"
    }, [_c('img', {
      attrs: {
        "src": '/static/img/dashboard/ic_' + item.device_platform + '.svg'
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "text-wrapper"
    }, [_vm._v(_vm._s(_vm.$t('device')) + " " + _vm._s(index + 1) + _vm._s(_vm.currentLang === 'en' ? ': ' : '：') + _vm._s(item.name))])]), _vm._v(" "), _c('div', {
      staticClass: "delete"
    }, [_c('span', {
      staticClass: "modify-btn",
      on: {
        "click": function($event) {
          return _vm.$emit('showModifyModal', item.id, item.name)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "delete-btn",
      on: {
        "click": function($event) {
          return _vm.$emit('showDeleteModal', item.id)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('delete_btn')))])])])
  }), 0) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4ea6ca9e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/deviceManagement/DeviceManagementPC.vue
// module id = 1322
// module chunks = 1